const ONE_MINUTE_IN_SECONDS = 60;
export const ONE_HOUR_IN_SECONDS = 60 * ONE_MINUTE_IN_SECONDS;

const ONE_SECOND_IN_MS = 1000;
export const FIVE_SECONDS_IN_MS = 5 * ONE_SECOND_IN_MS;
export const ONE_MINUTE_IN_MS = ONE_MINUTE_IN_SECONDS * ONE_SECOND_IN_MS;
export const FIVE_MINUTES_IN_MS = 5 * ONE_MINUTE_IN_MS;
export const TEN_MINUTES_IN_MS = 10 * ONE_MINUTE_IN_MS;
export const ONE_HOUR_IN_MS = 60 * ONE_MINUTE_IN_MS;

export const API_MAX_PAGE_LIMIT = 50;
